import React from 'react';

import Spinner from 'component/Layout/Loader/Spinner';

import classNames from 'classnames';

import { QaIdentifier, useQa } from 'hooks/useQa';
import { useTranslation } from 'hooks/useTranslation';

import styles from '../AiSmartFilter.module.scss';
import { SearchState } from '../types';

export interface ApplyFilterButtonProps {
    searchState: SearchState;
    onApplyFilter: () => void;
    onCancelRequest: () => void;
}

const ApplyFilterButton: React.FC<ApplyFilterButtonProps> = ({
    searchState,
    onApplyFilter,
    onCancelRequest,
}) => {
    const { t } = useTranslation();
    const qaAttr = useQa(QaIdentifier.Ai_Smart_Filter_Cta);

    const handleClick = () => {
        if (searchState === 'Inactive') {
            onApplyFilter();
        } else {
            onCancelRequest();
        }
    };

    return (
        <span
            className={classNames(styles.ApplyFilter)}
            onClick={handleClick}
            {...qaAttr}
        >
            {searchState === 'Spinner' ? (
                <Spinner />
            ) : searchState === 'Active' ? (
                t('TRANS-stop-searching')
            ) : (
                t('TRANS-start-searching')
            )}
        </span>
    );
};

export default ApplyFilterButton;
